// ======================================================================
// File Name       : ServiceGroupSuperUserList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import {
  Form,
  Button,
  Col,
  Row,
  Table
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { DORMANT_STATE } from '../../constants';
import Pagination from '../Pagination';

class ServiceGroupSuperUserList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  shouldComponentUpdate(nextProps, nextState) {
    const shouldNotUpdate =
      this.props.searchResultSuperUser === nextProps.searchResultSuperUser &&
      this.props.editingServiceGroupSuperUser === nextProps.editingServiceGroupSuperUser &&
      this.props.checkedSuperUserOnPage === nextProps.checkedSuperUserOnPage;
    return !shouldNotUpdate;
  }

  render() {
    const { searchResultSuperUser, editingServiceGroupSuperUser, checkedSuperUserOnPage } = this.props;
    return (
      <div className="margin-left-10">
        <Row className="margin-top-10">
          <Col sm={2}>
            <Button variant="default" onClick={this.props.handleCheckAll}>全選択/解除</Button>
          </Col>
          <Col sm={10}>
            <Pagination
              className="justify-content-end"
              startPosition={searchResultSuperUser.startPosition}
              recordNum={searchResultSuperUser.recordNum}
              handlePageSelect={this.props.handlePageChange}
            />
          </Col>
        </Row>
        <Table striped hover className="margin-top-7 margin-bottom-10">
          <thead>
            <tr>
              <th className="col-md-1" />
              <th>管理ユーザー名</th>
              <th>ログインID</th>
            </tr>
          </thead>
          <tbody>
            {
              searchResultSuperUser && searchResultSuperUser.allSecernIds &&
              searchResultSuperUser.allSecernIds.map((userSecernId, index) => {
                const user = searchResultSuperUser.bySecernId[userSecernId];
                const checked = checkedSuperUserOnPage.indexOf(userSecernId) > -1;
                return (
                  <tr key={index} className={user.dormantState == DORMANT_STATE.INACTIVE ? 'inactive-class' : ''}>
                    <td>
                      <Form.Check
                        type='checkbox'
                        className="text-center margin-clear"
                        value={userSecernId}
                        checked={editingServiceGroupSuperUser[userSecernId] || checked}
                        disabled={!!editingServiceGroupSuperUser[userSecernId] || user.rootFlag}
                        onChange={this.props.handleSuperUserCheck} />
                    </td>
                    <td>{user.superuserName}</td>
                    <td>{user.loginId}</td>
                  </tr>
                );
              })
            }
          </tbody>
        </Table>
        <Row className="margin-top-10">
          <Col sm={12} className="text-center">
            <Button
              variant="primary"
              className="btn-96"
              onClick={this.props.handleAddBtn}
              disabled={!checkedSuperUserOnPage.length}>
              追加
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { serviceGroup, authority } = state;
  return { serviceGroup, authority: authority.authorityInfo };
};
export default connect(mapStateToProps)(ServiceGroupSuperUserList);
